import { createAsyncThunk } from '@reduxjs/toolkit';
import { MpOrdersApi, OrderLabelsRequest, OrderLabelsResponse } from '@/Api/MpOrders';
import { AppThunkApiConfig, RootState } from '@/Redux/RootReducer';
import { GenerateLabelsResponse } from '@/Api/Logistics/Responses/GenerateLabelsResponse';
import { GenerateLabelsRequest } from '@/Api/Logistics/Requests/GenerateLabelsRequest';
import { LabelPrintedStatusResponse } from '@/Api/Logistics/Responses/LabelPrintedStatusResponse';
import { LogisticsApi } from '@/Api/Logistics/LogisticsApi';
import { OrderLabelModel } from '@/Models';
import { stringUtils } from '@/Utils';

function fillLocalization(x: OrderLabelModel, state: RootState): any {
  x.countryName = stringUtils.enumToString(x.country, state.modalWindows.orderLabelPrintModalState.countryCodeOptions);
  x.userLogisticTypeName = stringUtils.enumToString(
    x.userLogisticTypeId,
    state.modalWindows.orderLabelPrintModalState.logisticTypeOptions,
  );
}

const getOrderLabelInfoRequest = createAsyncThunk<OrderLabelsResponse, OrderLabelsRequest, AppThunkApiConfig>(
  'orderLabelPrintModal/getOrderLabelInfo',
  async (request: OrderLabelsRequest, api) => {
    const state: RootState = api.getState();

    const response = await MpOrdersApi.getLabelInfoRequest(request);
    response.orderLabels?.forEach((x) => fillLocalization(x, state));
    return response;
  },
);

const generateLabelsRequest = createAsyncThunk<GenerateLabelsResponse, GenerateLabelsRequest>(
  'orderLabelPrintModal/savePackages',
  async (request) => {
    return LogisticsApi.generateLabels(request);
  },
);

const setPrintedStatusRequest = createAsyncThunk<LabelPrintedStatusResponse, number[]>(
  'orderLabelPrintModal/setLabelPrintedStatus',
  async (orderLabelIds: number[]) => {
    return LogisticsApi.setLabelPrintedStatus(orderLabelIds);
  },
);

export const asyncActions = {
  getOrderLabelInfoRequest,
  generateLabelsRequest,
  setPrintedStatusRequest,
};
